import React from "react";
import ReactHtmlParser from "react-html-parser";
import DynamicLink from "@herb/components/DynamicLink";
import replaceImageCdn from "@herb/utils/replaceImageCdn";
import HempBanSectionHead from "@herb/components/HempBan/HempBanSectionHead";
import "./index.css";

const isHerbUrl = url => !!(url || "").match(/^https?:\/\/(www\.)?herb\.co/g);

/**
 * "Products to consider before the changes take effect" — promo product cards.
 * Links to herb.co resolve to internal Gatsby routes via DynamicLink; anything
 * else opens in a new tab with the usual rel guards.
 */
const HempBanProducts = ({ beforeChanges }) => {
  if (!beforeChanges) {
    return null;
  }

  const { badgeText, heading, text, cards = [] } = beforeChanges;

  return (
    <section className="hb-section hb-products">
      <div className="hb-container">
        <HempBanSectionHead badgeText={badgeText} heading={heading}>
          {text ? <p className="hb-products-intro">{text}</p> : null}
        </HempBanSectionHead>

        {cards && cards.length ? (
          <div className="hb-products-grid">
            {cards.map((card, index) => {
              const external = card.buttonLink && !isHerbUrl(card.buttonLink);

              return (
                <article
                  className="hb-product-card"
                  key={`${card.heading || "product"}-${index}`}
                >
                  {card.image?.sourceUrl ? (
                    <div className="hb-product-media">
                      <img
                        src={replaceImageCdn(card.image.sourceUrl)}
                        alt={card.image.altText || card.heading || ""}
                        loading="lazy"
                      />
                      {card.cardBadge ? (
                        <span className="hb-product-badge hb-rich">
                          {ReactHtmlParser(card.cardBadge)}
                        </span>
                      ) : null}
                    </div>
                  ) : null}

                  <div className="hb-product-body">
                    {card.heading ? (
                      <h3 className="hb-product-heading">{card.heading}</h3>
                    ) : null}
                    {card.text ? (
                      <p className="hb-product-text">{card.text}</p>
                    ) : null}
                    {card.buttonLink && card.buttonText ? (
                      <DynamicLink
                        className="hb-product-cta"
                        to={card.buttonLink}
                        {...(external
                          ? { target: "_blank", rel: "noopener noreferrer" }
                          : {})}
                      >
                        {card.buttonText}
                      </DynamicLink>
                    ) : null}
                  </div>
                </article>
              );
            })}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default HempBanProducts;
